export default __webpack_public_path__ + "static/media/i-vin_ins.645b51d4.svg";